import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function SiteFooter() {
  return (
    <div class="row-  overlayfooter-" style={{width:'100%',height:'50px',position:'fixed',background:'maroon',bottom:'0',display:'flex',alignItems:'center',justifyContent:'center'}}>
			<p style={{color:'white',textAlign:'center'}}>Kshethrasuvidham News</p>
		</div>
  );
}

export default SiteFooter;

